import { Circ, Expo, TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as PIXI from "pixi.js";
import {Ease} from "../core/Animatable";
import {Container} from "../core/Container";
import {array} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import { Button, OutlinedButton } from "../gameobjects/Button";
import {AbstractGameState} from "./AbstractGameState";

import { Application } from "../Application";
import TrashGameModel from "../data/TrashGameModel";
import * as VO from "../data/VO";
import { Grover } from "../gameobjects/Grover";
import { Oscar } from "../gameobjects/Oscar";
import { OscarCollect } from "../gameobjects/OscarCollect";
import {TrashCollectIntroLayout} from "../layout/TrashCollectIntroLayout";
import { CaptionManager } from "../managers/CaptionManager";

export class TrashCollectIntroScreen extends AbstractGameState {

    public static readonly NAME = "TrashCollectIntroScreen";

    public static visited: boolean = false;

    public readonly bg = this.addChild(new Sprite());
    public readonly oscar = this.addChild(new Oscar());
    public readonly grover = this.addChild(new Grover());
    public readonly skipButton = this.addChild(new Button());
    public readonly homeButton = this.addChild(new OutlinedButton());
    protected analyticsScreenName: string = "4a Trash Blast_Clean-Up Screen";
    protected analyticsRoundName = "Trash Blast";

    public init(pSize: PIXI.Point, pData: {}) {
        TrashCollectIntroLayout.call(this);

        this.skipButton.onClick.add(() => {
            TrashCollectIntroScreen.visited = true;
            this.gotoNextState("TrashCollectScreen", {fromIntro: true});
        });
        this.homeButton.onClick.add(() => {
            this.trackEvent("gameMenuClick", {buttonName: "Home"});
            this.gotoNextState("MainMenu");
        });
        this.homeButton.clickSfx = "buttonclick";
        this.skipButton.clickSfx = "buttonclick";

        this.skipButton.visible = false;

        this.trackEvent("gameRoundStart", {roundNumber: Application.instance.round});
        TrashGameModel.roundStartTime = new Date().valueOf();
        super.init(pSize);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
        const bgm = HLF.Application.instance.audio.getAudioTrack("trash_blast_loop", HLF.AudioCategory.BGM) ?? HLF.Application.instance.audio.createAudioTrack("trash_blast_loop", HLF.AudioCategory.BGM);
        if (bgm.isPlaying() === false) {
            bgm.setLooped(true);
            bgm.play();
        }

        Application.instance.voiceover.playVO([...VO.TB_INTRO01, VO.TB_INTRO02, VO.TB_INTRO03], () => {
            TrashCollectIntroScreen.visited = true;
            this.gotoNextState("TrashCollectScreen", {fromIntro: true});
        });
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this.position.set((pSize.x - 1024) / 2, 0);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
        this.grover.update(pDeltaTime);
        this.oscar.update(pDeltaTime);
    }
}
